/** @jsx jsx */
import { jsx } from '@emotion/core'
import styled from '@emotion/styled'
import { Container as AdminContainer, ToolsContainer } from 'admin'
import { Container as ReportContainer } from 'reports'
import React, { useContext, useEffect, useState } from 'react'
// import initialize from 'core/component/app-initializer'
import JwtInjector from './JwtInjector'
import { connect } from 'react-redux'
import { LoginWhenUnAuthorized, HideWhenUnAuthorized } from 'security'
import { Container as CardDataContainer } from 'card-data'
import GadsOperationDataExportContainer from 'gads-operation-data-export'
import InterfaceDataExportContainer from 'interface-data'
import { Container as GadsValidationContainer } from 'gads-validation'
import { SwitchBoardContainer } from './switchboard'
import { MonthlyPerformanceDataContainer } from './monthlyperfdata'
import { PiWindContainer } from './piwind'
import AEPContainer from './aep'
import { KindleContainer } from './kindle'
import WindContainer from './wind'
import { MarginAnalysisContainer } from './marginanalysis'
import { CtInspectionContainer } from 'ctinspection'
import { PjmRouteContainer } from './pjm'
import { PjmAdminRouteContainer } from './pjmadmin'
import { MisoNetCapVerificationContainer } from './miso-netcapverf'
import { Wind2Container } from './wind2'
import { UnitHourlyPocContainer } from './aeci/unit-hourly-poc'
import { AeciHourlyEventcontainer } from './aeci/hourlyevent'
import {
  RouteOutageAnalysisContainer,
  getKpiSpec,
  getContribKeys,
  getCAContribKeys,
} from 'outage-analysis'
import setTitle from './title'
import { BrowserRouter, Route, Switch, useLocation } from 'react-router-dom'

import { Layout } from 'antd'
import ContextProvider, { ErrorContext } from 'context'
import {
  getPermitActions,
  getEnvConfig,
  getClientInfo,
  getApiTargetInfo,
  isExpiredJWTData,
} from 'core/selectors'
import { NonHydroContainer } from './nonhydro'
import { HydroContainer } from './hydro'
import SideNav from './SideNav'
import Version from 'admin/component/Versions'
import { processLogout, getMetaConfig } from './utils'
import MarginAnalysisContext from 'marginanalysis/MarginAnalysisContext'
import { MsAuthenticated } from 'ms-auth-support'
import { SolarContainer } from 'solar'
// import { hasAccesPermits } from 'core/utils'
// import * as ScreenPermissions from 'core/EventActions'
import { OutageAnalyzerDataRoutes } from './core/RotesList'
import { ClecoRouteExport } from 'cleco'
import { TPSContainer } from 'admin/tps'
import { getSystemConfigurationInfo, logoutCall } from './api/pgads'
import { GridTable } from './grid-filter/GridFilter'
import InactivityModal from './InactivityModal'
import VersionsNYIso from './admin/component/VersionsNYIso'
import { AEPAcaSppReportRouteNav } from 'aep/aca-spp-report'
const contextUrl = getMetaConfig('contextUrl', null)

const development =
  process.env.NODE_ENV === undefined || process.env.NODE_ENV !== 'production'
const basename =
  contextUrl != null && contextUrl.trim().length > 0
    ? `/${contextUrl}`
    : development
    ? undefined
    : '/ui'
const { Content, Footer } = Layout

export const MenuButtonWrapper = styled.div`
  cursor: pointer;
  transition: color 0.3s;
  display: flex;
  height: 64px;
  padding: 0 24px;
  cursor: pointer;
  display: flex;
  background-color: ${props => (props.bc ? props.bc : 'unset')};
  align-items: center;
  &:hover {
    background-color: ${props => (props.hbc ? props.hbc : '#f4f4f4')};
  }
`

const ContentStyle = styled.div`
  margin-left: 10px;
`

/* eslint-disable */
const gitHash = GIT_HASH
// const gitTag = GIT_TAG
/* eslint-enable */
console.log('Commit point id ', gitHash)
export const logout = (e, apiTargetInfo) => {
  e.preventDefault()

  if (apiTargetInfo) {
    logoutCall(apiTargetInfo).fork(
      _ => {
        processLogout()
      },
      _ => {
        processLogout()
      }
    )
  } else processLogout()
}

const Header = ({ collapsed, theme }) => (
  <HideWhenUnAuthorized>
    <Layout.Header
      style={{
        // backgroundColor: '#fff',
        // backgroundColor: '#010101',
        padding: '0',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <SideNav collapsed={collapsed} theme={theme} />
    </Layout.Header>
  </HideWhenUnAuthorized>
)

// const IDLE_WARNING_SECONDS = 60

const Contents = ({
  actionPermits,
  envConfig,
  kpiSpec,
  trendGraphs,
  contribKeys,
  caContribKeys,
  CLIENT,
  apiTargetInfo,
  isLogedOut,
}) => {
  const { onMenuChnageCall } = useContext(MarginAnalysisContext)

  const [collapsed, setCollapsed] = useState(false)
  const toggleSiderCollapse = () => setCollapsed(!collapsed)
  const menuTheme = 'dark'
  const theme = { mode: menuTheme }
  const pathName = useLocation().pathname
  setTitle(pathName)

  useEffect(onMenuChnageCall, [onMenuChnageCall])

  const { setError } = useContext(ErrorContext)
  const [userIdleTime, setUserIdleTime] = useState()
  const [userIdleWarningTime, setUserIdleWarningTime] = useState()
  useEffect(() => {
    if (isLogedOut) return
    getSystemConfigurationInfo(apiTargetInfo).fork(setError, d => {
      const sysConfigInactivity = d.find(
        s => s.key === 'INACTIVITY_TIMEOUT_MINUTES'
      ) || {
        value: -1,
      }
      setUserIdleTime(sysConfigInactivity?.value)
      const sysConfigInactivityWarning = d.find(
        s => s.key === 'INACTIVITY_TIMEOUT_WARNING_SECONDS'
      ) || {
        value: 60,
      }
      setUserIdleWarningTime(sysConfigInactivityWarning?.value)
    })
  }, [apiTargetInfo, isLogedOut, setError])
  //   onMenuChnageCall()

  return (
    <Layout
      style={{
        minHeight: '100vh',
        minWidth: '800px',
        // marginLeft: !collapsed ? '200px' : '80px',
      }}
    >
      <Layout>
        <Header
          collapsed={collapsed}
          toggleSiderCollapse={toggleSiderCollapse}
          theme={theme}
        />
        {userIdleTime > 0 && userIdleWarningTime > 0 && (
          <InactivityModal
            userIdleTime={userIdleTime}
            userIdleWarningTime={userIdleWarningTime}
          />
        )}
        <Content style={{ height: 'calc(100vh - 105px)' }}>
          <Switch>
            <Route
              key="/"
              render={props => {
                if (props.location.pathname.startsWith('/init')) return null
                return (
                  <LoginWhenUnAuthorized>
                    <ContentStyle>
                      <Route exact path="/gridfilter" component={GridTable} />
                      <RouteOutageAnalysisContainer
                        key="analytics-container"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                        kpiSpec={kpiSpec}
                        trendGraphs={trendGraphs}
                        contribKeys={contribKeys}
                        caContribKeys={caContribKeys}
                      />
                      <Route exact path="/versions" component={Version} />
                      <Route
                        exact
                        path="/versionsnyiso"
                        component={VersionsNYIso}
                      />
                      <ToolsContainer
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <AdminContainer
                        key="admin-container"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                        CLIENT={CLIENT}
                      />
                      <ReportContainer
                        key="report-container"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <CardDataContainer
                        key="card-data"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <GadsValidationContainer
                        key="validation"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <GadsOperationDataExportContainer
                        key="operation-data"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <NonHydroContainer
                        key="nonhydro-data"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <HydroContainer
                        key="hydro-data"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <InterfaceDataExportContainer
                        key="interface-data"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />

                      <SwitchBoardContainer
                        key="switchboard-data"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <MonthlyPerformanceDataContainer
                        key="monthly-perf-data-main"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <AEPContainer
                        key="aep"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <WindContainer
                        key="wind"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <PiWindContainer
                        key="piwind"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <MarginAnalysisContainer
                        key="marginanacontainermain"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <KindleContainer
                        key="kindlemysql"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <CtInspectionContainer
                        key="ct-inspection-container"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <PjmRouteContainer
                        key="pjm-container"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <PjmAdminRouteContainer
                        key="pjm-container-admin-1"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <MisoNetCapVerificationContainer
                        key="miso-container-admin"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <Wind2Container
                        key="pjm-container-admin-2"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <SolarContainer
                        key="pjm-container-admin-3"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <OutageAnalyzerDataRoutes
                        key="outage-analysis"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <ClecoRouteExport
                        key="cleco"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                      <TPSContainer
                        key="genon-tps"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                        CLIENT={CLIENT}
                      />
                      <AEPAcaSppReportRouteNav
                        key="aep-acap-spp-report"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                        CLIENT={CLIENT}
                      />
                      <Route
                        path="/unit-hourly-poc"
                        key="unit-hourly-poc"
                        exact
                        component={UnitHourlyPocContainer}
                      />
                      <AeciHourlyEventcontainer
                        key="aeci-hourly-event"
                        actionPermits={actionPermits}
                        envConfig={envConfig}
                      />
                    </ContentStyle>
                  </LoginWhenUnAuthorized>
                )
              }}
            />
            <Route key="injector" path="/init" component={JwtInjector} />
          </Switch>
        </Content>
        <Footer style={{ textAlign: 'center', padding: '10px' }}>
          Integ Enterprise Consulting © {new Date().getFullYear()}
        </Footer>
      </Layout>
    </Layout>
  )
}

const Dashboard = ({ actionPermits, saveJwt, envConfig, ...props }) => (
  <ContextProvider>
    <BrowserRouter basename={basename}>
      <MsAuthenticated saveJwt={saveJwt}>
        <Contents
          actionPermits={actionPermits}
          envConfig={envConfig}
          {...props}
        />
      </MsAuthenticated>
    </BrowserRouter>
  </ContextProvider>
)

const mapStateToProps = state => ({
  actionPermits: getPermitActions(state),
  envConfig: getEnvConfig(state),
  kpiSpec: getKpiSpec(state),
  contribKeys: getContribKeys(state),
  caContribKeys: getCAContribKeys(state),
  CLIENT: getClientInfo(state),
  apiTargetInfo: getApiTargetInfo(state),
  isLogedOut: isExpiredJWTData(state),
})
export default connect(mapStateToProps)(Dashboard)
